/**
 * Construct the group map key to be a combination of GroupId and mailboxId as the
 * standard groups' GroupIds are same across accounts
 */
export default function getCalendarGroupKey(mailboxId: string, groupId: string): string {
    return `${groupId}_${mailboxId}`;
}
